import { render, staticRenderFns } from "./CompetitionCard.vue?vue&type=template&id=eeb6d9c4&scoped=true"
import script from "./CompetitionCard.vue?vue&type=script&lang=js"
export * from "./CompetitionCard.vue?vue&type=script&lang=js"
import style0 from "./CompetitionCard.vue?vue&type=style&index=0&id=eeb6d9c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb6d9c4",
  null
  
)

export default component.exports